const { CircularBinGeometry } = require('./circular-bin-geometry');
const { RectangularBinGeometry } = require('./rectangular-bin-geometry');

exports.binGeometryFromBin = (bin) => {
  switch (bin.dimensions.shape) {
  case 'circular':
    return new CircularBinGeometry(bin);
  case 'rectangular':
    return new RectangularBinGeometry(bin);
  default:
    throw new Error(`Unsupported bin shape: ${bin.dimensions.shape}`);
  }
};

/**
 * @deprecated
 */
exports.distanceToBin = ([x, y, z], bin) => exports.binGeometryFromBin(bin).distanceToBin([x, y, z]);

/**
 * @deprecated
 */
exports.isPointInsideBin = ([x, y, z], bin) => exports.binGeometryFromBin(bin).isPointInsideBin([x, y, z]);

/**
 * @deprecated
 * Returns a 3D vector representing the point that the top of the bracket attaches to the bin.
 * Co-ordinate system for this method: [0, 0, 0] is the center of the bottom of the hopper, positive z is up toward the top of the bin
 * @param {Object} bin
 * @returns {[number, number, number]} [x, y, z] in meters
 */
exports.bracketAttachmentPoint = (bin) => exports.binGeometryFromBin(bin).bracketAttachmentPoint();

/**
 * @deprecated
 */
exports.bracketToCameraVector = (bin) => exports.binGeometryFromBin(bin).bracketToCameraVector();

/**
 * @deprecated
 * Returns the amount the bracket is rotated (from normal) in radians along the z-axis
 * @param {Object} bin
 * @returns {number} in radians
 */
exports.bracketRotationForBin = (bin) => exports.binGeometryFromBin(bin).bracketRotationForBin();

/**
 * @deprecated
 * Assuming the camera is pointed at the bottom of the hopper, computes the expected pan and tilt of the camera
 * @param bin
 * @returns {{tilt: number, pan: number}}
 */
exports.estimatedCameraAngleForBin = (bin) => exports.binGeometryFromBin(bin).estimatedCameraAngleForBin();
